import { render, staticRenderFns } from "./DescriptionForm.vue?vue&type=template&id=a5a1d110&"
import script from "./DescriptionForm.vue?vue&type=script&lang=js&"
export * from "./DescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionForm.vue?vue&type=style&index=0&id=a5a1d110&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports